<template>
  <base-dialog width="560px" show-close :visible.sync="visible" class="rule-dialog">
    <template v-slot:header>{{ ruleOperationMap[operation] }}</template>
    <el-form ref="form" :model="ruleInfo" label-width="100px" :rules="rules" label-position="left">
      <el-form-item label="指标" prop="quota">
        <normal-select
          :select-list="getOptions(ruleInfo.quota)"
          :selected-item.sync="ruleInfo.quota"
          filterable
        ></normal-select>
      </el-form-item>
      <el-form-item label="格式类型" prop="type">
        <normal-select
          :select-list="colorTypeList"
          :selected-item.sync="ruleInfo.type"
          filterable
        ></normal-select>
      </el-form-item>
      <el-form-item v-if="ruleInfo.type == '区间色'" label="条件" prop="conditions">
        <conditions :rule="ruleInfo"></conditions>
      </el-form-item>
      <template v-else-if="ruleInfo.type == '渐变色'">
        <el-form-item label="配色方案" prop="colorScheme">
          <el-select
            v-model="ruleInfo.colorScheme"
            placeholder="请选择"
            popper-class="color-scheme"
          >
            <el-option
              v-for="item in colorList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
              <div class="color-item">
                <div
                  class="color"
                  :style="
                    'background: linear-gradient(to right,' +
                      item.color[0] +
                      ',' +
                      item.color[1] +
                      ')'
                  "
                ></div>
                <div class="label">{{ item.label }}</div>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="显示效果">
          <div
            class="display"
            :style="'background: linear-gradient(to right,' + curColor[0] + ',' + curColor[1] + ')'"
          ></div>
        </el-form-item>
      </template>
      <template v-else-if="ruleInfo.type == '数据条'">
        <el-form-item label="配色方案" prop="conditions">
          <data-bar-popper
            :cur-data="{ positive: ruleInfo.positive, negative: ruleInfo.negative }"
            @changeData="changeData"
          ></data-bar-popper>
        </el-form-item>
        <el-form-item label="显示效果">
          <div class="data-bar-display">
            <div class="left">
              <div class="negative" :style="'background:' + ruleInfo.negative"></div>
            </div>
            <div class="right">
              <div class="positive value" :style="'background:' + ruleInfo.positive">100</div>
              <div class="value">-50</div>
            </div>
          </div>
        </el-form-item>
      </template>
    </el-form>
    <template v-slot:footer>
      <span class="dialog-footer">
        <base-button @click="visible = false">取消</base-button>
        <base-button type="primary" @click="submit">确认</base-button>
      </span>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseButton from "@/components/UIComponents/Button"
import NormalSelect from "@/components/UIComponents/NormalSelect"
import {
  ruleOperationMap,
  colorTypeList,
  colorList
} from "@/views/Backend/Admin/Statistics/chartEdit/static"
import Conditions from "@/views/Backend/Admin/Statistics/chartEdit/Conditions"
import DataBarPopper from "@/components/BaseComponents/DataBarPopper"

export default {
  name: "rule-dialog",
  components: { DataBarPopper, Conditions, NormalSelect, BaseDialog, BaseButton },
  props: {
    operation: String,
    rule: Object,
    quotas: Array,
    extraRules: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      ruleOperationMap,
      colorTypeList,
      colorList,
      visible: false,
      ruleInfo: {},
      rules: {
        quota: [{ required: true, message: "请选择指标", trigger: "change" }],
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
        colorScheme: [{ required: true, message: "请选择配色类型", trigger: "change" }]
      }
    }
  },
  computed: {
    quotaList() {
      return (
        this.quotas
          ?.filter(quota => !quota.hidden)
          .map(quota => ({ label: quota.name, value: quota.id })) || []
      )
    },
    curColor() {
      return (
        this.colorList.find(item => item.value === this.ruleInfo.colorScheme)?.color || [
          "rgb(181, 233, 245)",
          "rgb(3, 97, 229)"
        ]
      )
    }
  },
  methods: {
    open() {
      this.ruleInfo = this.rule
      this.visible = true
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.$emit("submit", this.ruleInfo)
        this.$refs.form.clearValidate()
        this.visible = false
      })
    },
    changeData(item) {
      this.ruleInfo.positive = item.positive
      this.ruleInfo.negative = item.negative
    },
    getOptions(quotaId) {
      let selectedIds = this.getSelectedIds(quotaId)
      return this.quotaList?.filter(quota => !selectedIds.includes(quota.value))
    },
    getSelectedIds(quotaId) {
      let result = []
      this.extraRules
        .filter(rule => rule.quota !== quotaId)
        .forEach(rule => {
          if (rule.quota) result.push(rule.quota)
        })
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
.rule-dialog {
  .el-select {
    width: 100%;
  }
  .display {
    width: 100%;
    height: 32px;
  }
  .data-bar-display {
    width: 100%;
    height: 60px;
    border: 1px solid #e9e9e9;
    display: flex;
    .left {
      flex: 1;
      .negative {
        height: 30px;
        margin-top: 30px;
      }
    }
    .right {
      flex: 2;
      .positive {
        height: 30px;
      }
      .value {
        display: flex;
        align-items: center;
        height: 30px;
        justify-content: flex-end;
        padding-right: 10px;
      }
    }
  }
  ::v-deep .el-dialog {
    .el-dialog__body {
      padding: 20px;
      color: unset;
    }
    .el-popover__reference-wrapper {
      .data-bar-color {
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #e9e9e9;
        cursor: pointer;
        .item {
          width: 16px;
          height: 32px;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.color-scheme {
  .color-item {
    display: flex;
    align-items: center;
    .color {
      width: 160px;
      height: 24px;
      margin-right: 10px;
    }
  }
}
</style>
